/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemRoomArTrackableDefinitionFromJSON, StreemRoomArTrackableDefinitionToJSON, } from './';
export function WallItemArTrackableStatusFromJSON(json) {
    return WallItemArTrackableStatusFromJSONTyped(json, false);
}
export function WallItemArTrackableStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'trackableId': !exists(json, 'trackable_id') ? undefined : json['trackable_id'],
        'trackableStatus': !exists(json, 'trackable_status') ? undefined : json['trackable_status'],
        'trackableUpdatesProvider': !exists(json, 'trackable_updates_provider') ? undefined : json['trackable_updates_provider'],
        'trackableType': !exists(json, 'trackable_type') ? undefined : json['trackable_type'],
        'trackableDefinition': !exists(json, 'trackable_definition') ? undefined : StreemRoomArTrackableDefinitionFromJSON(json['trackable_definition']),
    };
}
export function WallItemArTrackableStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'trackable_id': value.trackableId,
        'trackable_status': value.trackableStatus,
        'trackable_updates_provider': value.trackableUpdatesProvider,
        'trackable_type': value.trackableType,
        'trackable_definition': StreemRoomArTrackableDefinitionToJSON(value.trackableDefinition),
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemArTrackableStatusTrackableStatus;
(function (WallItemArTrackableStatusTrackableStatus) {
    WallItemArTrackableStatusTrackableStatus["NORMAL"] = "TRACKABLE_STATUS_NORMAL";
    WallItemArTrackableStatusTrackableStatus["PAUSED"] = "TRACKABLE_STATUS_PAUSED";
    WallItemArTrackableStatusTrackableStatus["STOPPED"] = "TRACKABLE_STATUS_STOPPED";
    WallItemArTrackableStatusTrackableStatus["INVALID"] = "TRACKABLE_STATUS_INVALID";
})(WallItemArTrackableStatusTrackableStatus || (WallItemArTrackableStatusTrackableStatus = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArTrackableStatusTrackableUpdatesProvider;
(function (WallItemArTrackableStatusTrackableUpdatesProvider) {
    WallItemArTrackableStatusTrackableUpdatesProvider["DATATRACK"] = "STREAMING_MESSAGE_PROVIDER_DATA_TRACK";
    WallItemArTrackableStatusTrackableUpdatesProvider["INVALID"] = "STREAMING_MESSAGE_PROVIDER_INVALID";
    WallItemArTrackableStatusTrackableUpdatesProvider["TWILIOSYNCSTREAM"] = "STREAMING_MESSAGE_PROVIDER_TWILIO_SYNC_STREAM";
})(WallItemArTrackableStatusTrackableUpdatesProvider || (WallItemArTrackableStatusTrackableUpdatesProvider = {}));
/**
* @export
* @enum {string}
*/
export var WallItemArTrackableStatusTrackableType;
(function (WallItemArTrackableStatusTrackableType) {
    WallItemArTrackableStatusTrackableType["FEATUREPOINT"] = "TRACKABLE_TYPE_FEATURE_POINT";
    WallItemArTrackableStatusTrackableType["INVALID"] = "TRACKABLE_TYPE_INVALID";
    WallItemArTrackableStatusTrackableType["MARKER2D"] = "TRACKABLE_TYPE_MARKER_2D";
    WallItemArTrackableStatusTrackableType["MARKER3D"] = "TRACKABLE_TYPE_MARKER_3D";
    WallItemArTrackableStatusTrackableType["MESH"] = "TRACKABLE_TYPE_MESH";
    WallItemArTrackableStatusTrackableType["PLANE"] = "TRACKABLE_TYPE_PLANE";
    WallItemArTrackableStatusTrackableType["STATIC"] = "TRACKABLE_TYPE_STATIC";
})(WallItemArTrackableStatusTrackableType || (WallItemArTrackableStatusTrackableType = {}));
//# sourceMappingURL=WallItemArTrackableStatus.js.map